import { Box, Divider, Typography } from "@mui/material";
import SelectComponent from "../Select/Select";
import Grid from "@mui/material/Unstable_Grid2";
import ResetFiltersButton from "./ResetFiltersButton";
import { getComponent } from "./utils";
import ButtonComponent from "../Button/Button";
import { semanticColors } from "../../utils/colors";
import { typography } from "../../utils/typography";
import { useTranslation } from "react-i18next";

export default function FiltersDesktop({
  state,
  filters,
  onChangeFilters,
  onChangeSort,
  sortFields,
  spaceItems,
  resultsLength,
  onChangeReset,
  buttonDownloadFile
}: any) {
  const { t } = useTranslation();
  const sortDirections = [
    { label: t("filters.ascending"), value: "asc" },
    { label: t("filters.descending"), value: "desc" }
  ];

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: "16px" }}>
      <Grid spacing={spaceItems} container>
        {filters.map((input: any) => {
          const Component: any = getComponent(input.component);
          return (
            <Grid {...input.size} key={input.id}>
              <Component
                onChange={(value: any) => {
                  onChangeFilters(input.id, value);
                }}
                value={state.filters[input.id]}
                {...input.props}
              />
            </Grid>
          );
        })}
      </Grid>

      <Divider sx={{ borderColor: semanticColors.border.middle }} />

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between"
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: "16px" }}>
          {resultsLength ? (
            <Typography
              sx={{ ...typography.body.l, color: semanticColors.text.primary }}
            >
              {t("filters.results", { count: resultsLength })}
            </Typography>
          ) : null}
          {onChangeReset && <ResetFiltersButton onClick={onChangeReset} />}
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
          {buttonDownloadFile && resultsLength ? (
            <ButtonComponent
              label={buttonDownloadFile.label}
              onClick={buttonDownloadFile.onClick}
            />
          ) : null}
          {sortFields && (
            <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <Typography
                sx={{
                  whiteSpace: "nowrap",
                  ...typography.body.l,
                  color: semanticColors.text.primary
                }}
              >
                {t("filters.sortBy")}
              </Typography>
              <Box sx={{ minWidth: 210, flexShrink: 0 }}>
                <SelectComponent
                  value={state.sort.field}
                  label={t("filters.parameter")}
                  onChange={(value: any) => {
                    onChangeSort("field", value);
                  }}
                  items={sortFields}
                />
              </Box>
              <Box sx={{ minWidth: 160, flexShrink: 0 }}>
                <SelectComponent
                  value={state.sort.by}
                  label={t("filters.direction")}
                  onChange={(value: any) => {
                    onChangeSort("by", value);
                  }}
                  items={sortDirections}
                />
              </Box>
            </Box>
          )}
        </Box>
      </Box>

      <Divider sx={{ borderColor: semanticColors.border.middle }} />
    </Box>
  );
}
